import React, { useState, useEffect } from "react";
import AdminHeader from "../../component/Header";
import Sidebar from "../../component/Sidebar";
import AdminFooter from "../../component/Footer";
import { ApiService } from "../../component/Services/apiservices";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Media() {
    // State Management
    const [showForm, setShowForm] = useState(false);
    const [editingId, setEditingId] = useState(null); 
    const [mediaItems, setMediaItems] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);

    // 1. Fetch data on load using the dynamic ApiService
    useEffect(() => {
        fetchMediaList();
    }, []);

    const fetchMediaList = async () => {
        try {
            // ApiService automatically applies the base URL dynamically based on your config
            const res = await ApiService.fetchData('/admin/media/getmedia');
            if (res?.status === 'success') {
                setMediaItems(res.data); 
            }
        } catch (error) {
            console.error("Error fetching media:", error);
            toast.error("Failed to load media list.");
        }
    };

    // Handle file selection
    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setSelectedFile(e.target.files[0]);
        }
    };

    // 2. Handle Add / Edit Submission (Uploads file using FormData dynamically)
    const handleSave = async () => {
        if (!selectedFile) {
            toast.error("Please choose a file first.");
            return;
        }

        const formData = new FormData();
        formData.append("image", selectedFile); 

        // Dynamic route path determination
        const endpoint = editingId 
            ? `admin/media/updatemedia/${editingId}` 
            : `admin/media/uploadmedia`;

        try {
            const res = await ApiService.postData(endpoint, formData);

            if (res?.status === 'success') {
                toast.success(res.message || "Saved Successfully");
                
                // Reset form state and go back to list
                setSelectedFile(null);
                setEditingId(null);
                setShowForm(false);    
                
                // Refresh table
                fetchMediaList();      
            } else {
                toast.error(res?.message || "Failed to save the image.");
            }
        } catch (error) {
            console.error("Save error:", error);
            toast.error("An error occurred while communicating with the server.");
        }
    };

    // 3. Handle Delete
    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this image?")) {
            try {
                const res = await ApiService.postData(`admin/media/deletemedia/${id}`);
                if (res?.status === 'success') {
                    toast.success("Image deleted successfully");
                    fetchMediaList(); 
                } else {
                    toast.error(res?.message || "Failed to delete.");
                }
            } catch (error) {
                console.error("Delete error:", error);
                toast.error("An error occurred during deletion.");
            }
        }
    };

    // Trigger Edit Mode
    const openEditForm = (id) => {
        setEditingId(id);
        setShowForm(true);
    };

    // Close Form safely
    const closeForm = () => {
        setShowForm(false);
        setEditingId(null);
        setSelectedFile(null);
    };

    return (
        <>
            <ToastContainer />
            <div id="layout-wrapper">
                <AdminHeader />
                <Sidebar />
                <div className="vertical-overlay"></div>

                <div className="main-content" style={{ backgroundColor: "#f4f5f8", minHeight: "100vh" }}>
                    
                    <div className="page-content" style={{ paddingTop: "85px" }}>
                        <div className="container-fluid">
                            
                            {/* --- PAGE HEADER --- */}
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <div>
                                    <h4 className="mb-1" style={{ fontWeight: "600", color: "#495057", fontSize: "16px" }}>Manage Media</h4>
                                    <div style={{ fontSize: '13px', color: "#878a99" }}>
                                        Dashboard &gt; {showForm ? (editingId ? "Edit Media" : "Add Media") : "Manage Media"}
                                    </div>
                                </div>
                                <div>
                                    {!showForm ? (
                                        <button 
                                            className="btn text-white px-3 py-1 d-flex align-items-center justify-content-center gap-1 shadow-sm" 
                                            style={{ backgroundColor: '#40a4f4', border: 'none', borderRadius: '4px', fontSize: '14px' }}
                                            onClick={() => setShowForm(true)}
                                        >
                                            <span style={{ fontSize: '18px', fontWeight: '300', marginBottom: '2px' }}>+</span> Add New
                                        </button>
                                    ) : (
                                        <button 
                                            className="btn btn-secondary px-3 py-1 shadow-sm" 
                                            style={{ borderRadius: '4px', fontSize: '14px' }}
                                            onClick={closeForm}
                                        >
                                            Back to List
                                        </button>
                                    )}
                                </div>
                            </div>

                            {showForm ? (
                                /* Form View (Add / Edit) */
                                <div className="card border-0 shadow-sm" style={{ borderRadius: '4px' }}>
                                    <div className="card-header bg-white border-bottom py-3 px-4">
                                        <h6 className="m-0" style={{ color: '#495057', fontSize: '15px' }}>
                                            {editingId ? "Edit Image" : "Add Image"}
                                        </h6>
                                    </div>
                                    <div className="card-body px-4 py-4">
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-md-auto me-3">
                                                <div className="d-flex align-items-center justify-content-center rounded overflow-hidden" style={{ height: '120px', width: '120px', backgroundColor: '#e9ecef', color: '#878a99' }}>
                                                    {selectedFile ? (
                                                        <img src={URL.createObjectURL(selectedFile)} alt="Preview" style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                                    ) : (
                                                        <span><strong>your</strong> logo*</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md">
                                                <label className="form-label mb-2" style={{ fontSize: '14px', color: '#495057' }}>Image:</label>
                                                <div className="input-group">
                                                    <input 
                                                        type="file" 
                                                        className="form-control" 
                                                        accept=".gif, .png, .jpg, .jpeg" 
                                                        onChange={handleFileChange}
                                                    />
                                                </div>
                                                <small className="text-muted mt-2 d-block" style={{ fontSize: '12px' }}>Accepted: gif, png, jpg. Max file size 2Mb</small>
                                            </div>
                                        </div>
                                        <div className="border-top pt-3 mt-4">
                                            <button 
                                                className="btn text-white px-4" 
                                                style={{ backgroundColor: '#40a4f4', border: 'none', borderRadius: '4px' }}
                                                onClick={handleSave}
                                            >
                                                {editingId ? "Update Image" : "Save"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                /* Table View */
                                <div className="card border-0 shadow-sm" style={{ borderRadius: '4px' }}>
                                    <div className="card-header bg-white border-bottom py-3 px-4">
                                        <h6 className="m-0" style={{ color: '#68717b', fontSize: '14px', fontWeight: '500' }}>Media Listings</h6>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <table className="table align-middle mb-0" style={{ borderCollapse: "collapse" }}>
                                                <thead>
                                                    <tr style={{ backgroundColor: "#f8f9fa", borderBottom: "1px solid #e9ecef" }}>
                                                        <th className="py-3 px-4 text-muted" style={{ width: '80px', fontWeight: '500', fontSize: '13px' }}>S.No.</th>
                                                        <th className="py-3 text-muted" style={{ width: '250px', fontWeight: '500', fontSize: '13px' }}>Media</th>
                                                        <th className="py-3 text-muted" style={{ fontWeight: '500', fontSize: '13px' }}>Media Link</th>
                                                        <th className="py-3 px-4 text-end text-muted" style={{ width: '120px', fontWeight: '500', fontSize: '13px' }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {mediaItems.length > 0 ? (
                                                        mediaItems.map((item, index) => (
                                                            <tr key={item.id} style={{ borderBottom: "1px solid #e9ecef" }}>
                                                                <td className="px-4 py-3" style={{ fontSize: '13px', color: '#495057' }}>{index + 1}</td>
                                                                <td className="py-3">
                                                                    <div style={{ padding: '3px', border: '1px solid #dee2e6', display: 'inline-block', borderRadius: '3px', backgroundColor: '#fff' }}>
                                                                        <img 
                                                                            src={item.img} 
                                                                            alt={`media-${item.id}`} 
                                                                            style={{ height: '45px', width: '90px', objectFit: 'cover', display: 'block' }} 
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td className="py-3">
                                                                    <span style={{ fontSize: '13px', color: '#495057', wordBreak: 'break-all' }}>
                                                                        {item.img}
                                                                    </span>
                                                                </td>
                                                                <td className="px-4 py-3 text-end">
                                                                    {/* EDIT BUTTON */}
                                                                    <button 
                                                                        className="btn btn-sm me-2 d-inline-flex align-items-center justify-content-center" 
                                                                        style={{ backgroundColor: '#e4f4ff', color: '#40a4f4', border: 'none', height: '28px', width: '28px', borderRadius: '4px' }}
                                                                        onClick={() => openEditForm(item.id)}
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                                            <path d="M12 20h9"></path>
                                                                            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                                                                        </svg>
                                                                    </button>

                                                                    {/* DELETE BUTTON */}
                                                                    <button 
                                                                        className="btn btn-sm d-inline-flex align-items-center justify-content-center" 
                                                                        style={{ backgroundColor: '#ffefef', color: '#f06548', border: 'none', height: '28px', width: '28px', borderRadius: '4px' }}
                                                                        onClick={() => handleDelete(item.id)}
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                                            <polyline points="3 6 5 6 21 6"></polyline>
                                                                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                                                            <line x1="10" y1="11" x2="10" y2="17"></line>
                                                                            <line x1="14" y1="11" x2="14" y2="17"></line>
                                                                        </svg>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center py-4 text-muted">
                                                                No media records found. Click "+ Add New" to upload an image.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                    <AdminFooter />
                </div>
            </div>
        </>
    );
}

export default Media;